import {SActionBtn, SAlert, SDrawerOrModal, SLowcodeList, STableActions, STags} from "shj-components";
import React, {useRef, useState} from "react";
import {config} from "./config.tsx";
import {get, isArray} from "lodash-es";
import {getCombinationProductList} from "@/services/product.ts";
import '@/pages/baseProduct/schemeProductList/index.module.less'
import SKUDetails from "@/pages/baseProduct/schemeProductList/components/SKUDetails";

const CombinationDetails = (props: any) => {
    const {onClose, record} = props;
    const listRef = useRef<any>();
    const [currentRecord, setCurrentRecord] = useState<any>({});
    const [isSkuDetails, setIsSkuDetails] = useState(false);

    const fetchList = ({current, pageSize, query}: any) => {
        return new Promise((resolve, reject) => {
            try {
                console.log('query', query)
                console.log('record', record)
                getCombinationProductList({
                    params: {pageId: current, pageSize},
                    data: {
                        ...query,
                        mainProductId: record?.id,
                        "queryApplyProductShop" : true, //查询spu门店-写死
                        "orderBys": [
                            {
                                "columnName": "id",
                                "asc": false
                            }
                        ],
                        "searchFlag": true
                    }
                }).then(
                    (res: any) => {
                        const records = get(res, "list");
                        records.map((item, index) => {
                            item.tableIndex = index + 1;
                        });
                        const total = get(res, "count");
                        console.log(1111, records);
                        resolve({records, total});
                    },
                ).catch(()=>{
                    reject({success: false});
                })
            } catch (e) {
                reject({success: false});
            }
        });
    };

    const onDetail = (obj) => {
        console.log(record?.companyId)
        // productId
        setCurrentRecord({
            ...obj,
            companyId:record?.companyId,
            searchOrgId:record?.searchOrgId,
        });
        setIsSkuDetails(true)
    }

    const extension = {
        request: {
            fetchList,
        },
        customRender: {
            enableRender(_, record: Record<string, any>) {
                const enabled = record?.spuEnabled;
                return (
                    <STags itemKey='' label={enabled ? '启用' : '禁用'} fontColor={enabled ? '#00A865' : '#EB3723'} bgColor={enabled ? '#D7F7EA' : '#FFEAE8'} />
                )
            },
            actionRender(_: null, record: Record<string, any>) {
                return <STableActions>
                    <SActionBtn onClick={() => onDetail(record)}>SKU详情</SActionBtn>
                </STableActions>
            }
        },
    };
    const rowClassName = (object: any) => {
        // applyProductShopList id 匹配
        const applyProductShopList = get(object, 'applyProductShopList');
        const applyProductShopListIds =isArray(applyProductShopList)?applyProductShopList.map(item => item.id):[];
        if (!applyProductShopListIds.includes(record?.companyId)&&!applyProductShopListIds.includes("0")&&!applyProductShopListIds.includes(record?.searchOrgId)) {
            return 'rowBgColor';
        }
        return '';
    };
    return (
        <SDrawerOrModal
            title={"组合详情"}
            open={props?.open}
            okText="保存"
            width={1000}
            onCancel={onClose}
            onClose={onClose}
            destroyOnClose={true}
            isHideCancelBtn={true}
            isHidenOkBtn={true}
        >
            <div className={"SDrawerOrModalBox"}>
                <div className={'modalTopBox'}>
                    <SAlert type="info">
                        <span className={'rowBgColor'}>红色字体行</span>表示该产品SKU数据异常：打包有配置查询门店可用，但产品SKU在供应链侧该门店可能已经缺断货或下架，需要联系总部打包人员处理
                    </SAlert>
                </div>
                <SLowcodeList
                    config={{...config}}
                    searchMode={"group"}
                    ref={listRef}
                    {...extension}
                    rowClassName={rowClassName}
                />
            </div>
            {/*组合详情*/}
            {
                isSkuDetails?<SKUDetails
                    open={isSkuDetails}
                    record={currentRecord}
                    onClose={() => {
                        setIsSkuDetails(false)
                        setCurrentRecord({})
                    }}
                />:null
            }
        </SDrawerOrModal>
    );
};

export default CombinationDetails;
